import NoSignature from "@material-ui/icons/Clear";
import SingleSignature from "@material-ui/icons/Done";
import DoubleSignature from "@material-ui/icons/DoneAll";
import Manager from "@material-ui/icons/HowToReg";
import ShiftLeader from "@material-ui/icons/People";
import BasicUser from "@material-ui/icons/Person";
import Settings from "@material-ui/icons/Settings";
import ContentView from "Components/ContentView/ContentView";
import ToggleBar from "Components/ToggleBar/ToggleBar";
import ToggleOption from "Components/ToggleBar/ToggleOption/ToggleOption";
import { RoleType } from "Models/Users/RoleType";
import React from "react";
import i18n from "Translations/i18n";
import styles from "./ChecklistTemplateSettings.scss";

interface IProps {
    selectedRole: string;
    selectedSingleSignatureRequired: boolean;
    selectedDoubleSignatureRequired: boolean;
    onRoleChanged(newValue: RoleType): void;
    onSignatureRequiredChanged(signatureRequired: boolean, doubleSignatureRequired: boolean): void;
}

export class ChecklistTemplateSettings extends React.Component<IProps> {

    constructor(props: IProps) {
        super(props);

        this.onRoleSelectionChanged = this.onRoleSelectionChanged.bind(this);
        this.onSignatureRequiredChanged = this.onSignatureRequiredChanged.bind(this);
    }

    public onRoleSelectionChanged(newValue: RoleType) {
        this.props.onRoleChanged(newValue);
    }
    public onSignatureRequiredChanged(newValue: string) {
        const newValues = newValue.split(",");
        this.props.onSignatureRequiredChanged(JSON.parse(newValues[0]), JSON.parse(newValues[1]));
    }

    public render() {
        return (
            <ContentView>
                <h1><Settings />{i18n.t("checklists.settings.title")}</h1>
                <div className={styles.settings}>
                    <div className={styles.table}>
                        <div className={styles.row}>
                            <div className={styles.column}>
                                <span>{i18n.t("checklists.settings.role.label")}</span>
                            </div>
                            <div className={styles.column}>
                                <ToggleBar selectedItem={this.props.selectedRole} onChange={this.onRoleSelectionChanged} fullWidth={true}>
                                    <ToggleOption value={RoleType.basic}><BasicUser /> {i18n.t("authentication.roles.basic")}</ToggleOption>
                                    <ToggleOption value={RoleType.shiftleader}><ShiftLeader /> {i18n.t("authentication.roles.shift_leader")}</ToggleOption>
                                    <ToggleOption value={RoleType.manager}><Manager /> {i18n.t("authentication.roles.manager")}</ToggleOption>
                                </ToggleBar>
                            </div>
                        </div>
                        <div className={styles.row}>
                            <div className={styles.column}>
                                <span>{i18n.t("checklists.settings.signature.label")}</span>
                            </div>
                            <div className={styles.column}>                                
                                <ToggleBar selectedItem={[this.props.selectedSingleSignatureRequired, this.props.selectedDoubleSignatureRequired].toString()} onChange={this.onSignatureRequiredChanged} fullWidth={true}>
                                    <ToggleOption value={[false, false].toString()}><NoSignature /> {i18n.t("checklists.settings.signature.none")}</ToggleOption>
                                    <ToggleOption value={[true, false].toString()}><SingleSignature /> {i18n.t("checklists.settings.signature.one")}</ToggleOption>
                                    <ToggleOption value={[true, true].toString()}><DoubleSignature /> {i18n.t("checklists.settings.signature.two")}</ToggleOption>
                                </ToggleBar>
                            </div>
                        </div>
                    </div>
                </div>
            </ContentView>
        );
    }
}

export default ChecklistTemplateSettings;


// WEBPACK FOOTER //
// ./src/Components/Pages/ChecklistTemplateDetailView/ChecklistTemplateSettings/ChecklistTemplateSettings.tsx